import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useUserRole } from '@/hooks/auth.hooks';

const ProtectedRoute: React.FC = () => {
  const navigate = useNavigate();

  const { hasNoRole } = useUserRole();

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      navigate('/login');
    } else if (hasNoRole && !location.pathname.startsWith('/user')) {
      navigate('/users');
    }
  });

  return <Outlet />;
};

export default ProtectedRoute;
